"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@itwin/itwinui-css/css/dialog.css");
const DialogTitleBar_js_1 = require("./DialogTitleBar.js");
const DialogContent_js_1 = require("./DialogContent.js");
const DialogBackdrop_js_1 = require("./DialogBackdrop.js");
const DialogContext_js_1 = require("./DialogContext.js");
const DialogButtonBar_js_1 = require("./DialogButtonBar.js");
const DialogMain_js_1 = require("./DialogMain.js");
const index_js_1 = require("../utils/index.js");
/**
 * Dialog component.
 * @example
 * <Dialog
 *   isOpen={isOpen}
 *   onClose={() => setIsOpen(false)}
 *   trapFocus
 *   preventDocumentScroll
 * >
 *   <Dialog.Backdrop />
 *   <Dialog.Main aria-modal>
 *    <Dialog.TitleBar>My dialog title</Dialog.TitleBar>
 *    <Dialog.Content>
 *      Here is my dialog content
 *    </Dialog.Content>
 *    <Dialog.ButtonBar>
 *      <Button styleType='high-visibility'>Confirm</Button>
 *      <Button>Close</Button>
 *    </Dialog.ButtonBar>
 *   </Dialog.Main>
 * </Dialog>
 */
exports.Dialog = Object.assign(React.forwardRef((props, ref) => {
    const { children, trapFocus = false, setFocus = false, preventDocumentScroll = false, isOpen = false, isDismissible = true, closeOnEsc = true, closeOnExternalClick = false, onClose, isDraggable = false, isResizable = false, relativeTo = 'viewport', className, style, ...rest } = props;
    const dialogRootRef = React.useRef(null);
    const refs = (0, index_js_1.useMergedRefs)(ref, dialogRootRef);
    return (React.createElement(DialogContext_js_1.DialogContext.Provider, { value: {
            isOpen,
            onClose,
            closeOnEsc,
            closeOnExternalClick,
            isDismissible,
            preventDocumentScroll,
            trapFocus,
            setFocus,
            isDraggable,
            isResizable,
            relativeTo,
            dialogRootRef,
        } },
        React.createElement("div", { className: (0, classnames_1.default)('iui-dialog-wrapper', className), "data-iui-relative": relativeTo === 'container', ref: refs, style: {
                ...style,
            }, ...rest }, children)));
}), {
    Backdrop: DialogBackdrop_js_1.DialogBackdrop,
    Main: DialogMain_js_1.DialogMain,
    TitleBar: DialogTitleBar_js_1.DialogTitleBar,
    Content: DialogContent_js_1.DialogContent,
    ButtonBar: DialogButtonBar_js_1.DialogButtonBar,
});
exports.default = exports.Dialog;
